import React from 'react';
import moment from 'moment';

import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import LightbulbIcon from 'buyside/svgs/lightbulb.svg';
import Link, { LINK_TYPES } from 'buyside/components/presentation/Link/link';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

import { WhitePaperCategoryNamesFragment } from 'interfaces/graphql-typings';
import { userUrl, whitePaperShowUrl } from 'buyside/util/urlHelper';
import { truncateText } from 'buyside/util/textHelpers';

import styles from './styles.scss';

const CategoryItem: React.FC<{ categoryTitle: string; subcategories: string }> = ({
  categoryTitle,
  subcategories
}) => {
  return (
    <p className={styles.categoryItem}>
      <span>{categoryTitle}:</span> {subcategories}
    </p>
  );
};

const RecentWhitePaper: React.FC<{
  displayName: string;
  elevatorPitch: string;
  id: string;
  onWhitePaperLinkClick?: () => void;
  onUserLinkClick?: () => void;
  profileImageUrl: string;
  showUserDetails: boolean;
  submittedAt: string;
  title: string;
  userId: string;
} & WhitePaperCategoryNamesFragment> = ({
  displayName,
  elevatorPitch,
  esgNames,
  globalMacroNames,
  geographyNames,
  id,
  onUserLinkClick,
  onWhitePaperLinkClick,
  profileImageUrl,
  sectorNames,
  showUserDetails,
  submittedAt,
  title,
  userId
}) => {
  return (
    <>
      <header className={styles.header}>
        <LightbulbIcon className={styles.lightBulb} />
        <Link
          className={styles.title}
          to={whitePaperShowUrl(id)}
          type={LINK_TYPES.PLAIN}
          onMouseDown={onWhitePaperLinkClick}
        >
          {title}
        </Link>
      </header>

      <main className={styles.main}>
        <ProfileImage source={profileImageUrl} size={'small'} />
        <div className={styles.content}>
          <h3>
            {showUserDetails ? (
              <Link to={userUrl(userId)} type={LINK_TYPES.PLAIN} onMouseDown={onUserLinkClick}>
                {displayName}
              </Link>
            ) : (
              <AnonymousUserDisplay anonUser={{ title: '' }} />
            )}
          </h3>
          <time>Submitted {moment(new Date(submittedAt)).fromNow()}</time>

          {Boolean(esgNames) && <CategoryItem categoryTitle="ESG" subcategories={esgNames} />}
          {Boolean(geographyNames) && (
            <CategoryItem categoryTitle="Geographies" subcategories={geographyNames} />
          )}
          {Boolean(globalMacroNames) && (
            <CategoryItem categoryTitle="Global Macro" subcategories={globalMacroNames} />
          )}
          {Boolean(sectorNames) && (
            <CategoryItem categoryTitle="Sectors" subcategories={sectorNames} />
          )}

          <p className={styles.elevatorPitch}>
            <Link
              to={whitePaperShowUrl(id)}
              type={LINK_TYPES.PLAIN}
              onMouseDown={onWhitePaperLinkClick}
            >
              {truncateText(elevatorPitch, 115)}
            </Link>
          </p>
        </div>
      </main>
    </>
  );
};

export default RecentWhitePaper;
